(function() {
  'use strict';

  function initializeCollectionFilters() {
    var filterRoot = document.querySelector('[data-swg-collection-filters]');

    if (!filterRoot) {
      return;
    }

    var filters = Array.prototype.slice.call(
      filterRoot.querySelectorAll('[data-swg-collection-filter]')
    );

    if (!filters.length) {
      return;
    }

    filters.forEach(function(filter) {
      filter.addEventListener('change', function() {
        var activeTags = filters
          .map(function(select) {
            return select.value;
          })
          .filter(Boolean);
        var collectionUrl = filterRoot.getAttribute('data-collection-url');
        var query = new URLSearchParams(window.location.search);

        query.delete('page');

        var destination = collectionUrl;
        if (activeTags.length) {
          destination += '/' + activeTags.join('+');
        }

        var queryString = query.toString();
        window.location.href = destination + (queryString ? '?' + queryString : '');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCollectionFilters);
  } else {
    initializeCollectionFilters();
  }
})();
